module.exports = __webpack_public_path__ + "img/HW.015de864.svg";